import React from 'react';

export function Filter({ item, onClick }) {
	return <div className="tag" onClick={() => { onClick(item) }}>
		<span className="icon">{item.src}</span>
		<span className="desc">{item.description}</span>
	</div>
}

export function ActiveFilters({ filters, onClick }) {
	var view = filters.map(function(item, index) {
		return <Filter key={index} item={item} onClick={onClick} />
	});

	return <div>{ view }</div>;
}



// WEBPACK FOOTER //
// ./src/modules/app/filters.js